import { ReactNode } from "react";
import { create } from "zustand";

interface ModalState {
  isOpen: boolean;
  isDelete: boolean;
  title: string;
  message: ReactNode;
  onConfirm: () => Promise<void>;
  openModal: (
    title: string,
    message: string,
    onConfirm: () => Promise<void>,
    isDelete?: boolean
  ) => void;
  closeModal: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  isOpen: false,
  isDelete: false,
  title: "",
  message: "",
  onConfirm: async () => {},
  openModal: (title, message, onConfirm, isDelete = false) =>
    set({ isOpen: true, title, message, onConfirm, isDelete }),
  closeModal: () =>
    set({
      isOpen: false,
      title: "",
      message: "",
      onConfirm: async () => {},
      isDelete: false,
    }),
}));
